export default __webpack_public_path__ + "a4380067c3c849a3c250dc6b95a04c1e.svg";